<template>
<div>
    <div v-if="isOpen" class="absolute fill flex hover-listener" style="top: 0; left: 0; z-index: 1000; background: var(--white)">

        <div class="absolute flex show-hover section pa10" style="top: 10px; left: 10px">
            <i class="options icon-arrow-left" @click="isOpen = false" v-tooltip="'Volver'"></i>
        </div>

        <div class="absolute flex show-hover section pa10" style="top: 10px; right: 10px">
            <i class="options icon-cog" @click="ChangeNumberSize" v-tooltip="'Cambiar Número de Dígitos'"></i>
            <i class="options icon-minus ml5" @click="ChangeFontSize(-1)" v-tooltip="'Disminuir Tamaño de Letra'"></i>
            <i class="options icon-plus ml5" @click="ChangeFontSize(1)" v-tooltip="'Aumentar Tamaño de Letra'"></i>
        </div>

        <div class="fill flex" :style="{fontSize: `${fontSize}px`}">
            <div class="flex-fill flex column">
                <div :style="{background: 'var(--dark-fc-3)', color: 'white', padding: '5px 20px'}">Preparando...</div>
                <div class="relative fill">
                    <div class="fill flex column absolute" style="flex-wrap: wrap; color: var(--dark-fc-3); font-weight: 500;">
                        <div style="padding: 5px 20px" v-for="ticket in ticketsGroups.preparing" :key="ticket">{{ticket}}</div>
                    </div>
                </div>
            </div>
            <div class="flex-fill flex column">
                <div :style="{background: 'var(--green)', color: 'white', padding: '5px 20px'}">¡Listo! <i class="icon icon-check ml10"></i></div>
                <div class="relative fill">
                    <div class="fill flex column absolute" style="flex-wrap: wrap; color: var(--green); font-weight: 500;">
                        <div style="padding: 5px 20px" v-for="ticket in ticketsGroups.ready" :key="ticket">{{ticket}}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
export default {
    props: {
        tickets: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            isOpen: false,
            fontSize: 40,
            numberSize: 10,
        }
    },
    mounted() {
        if(localStorage.readyDisplayFont) this.fontSize = parseInt(localStorage.readyDisplayFont);
        if(localStorage.readyDisplayDigits) this.numberSize = parseInt(localStorage.readyDisplayDigits);
    },
    methods: {
        Open() {
            this.isOpen = true;
        },
        ChangeFontSize(val)
        {
            this.fontSize += val;
            if(this.fontSize < 8) this.fontSize = 20;
            localStorage.readyDisplayFont = this.fontSize;
        },
        ChangeNumberSize() 
        {
            if(this.numberSize == 10) this.numberSize = 2;
            else if(this.numberSize == 2) this.numberSize = 3;
            else if(this.numberSize == 3) this.numberSize = 10;
            localStorage.readyDisplayDigits = this.numberSize;
        }
    },
    computed: {
        ticketsGroups() {
            let ret = {
                preparing: [],
                ready: []
            };
            this.tickets.forEach(ticket => {
                const skipLineOrder = ticket.source == 'INFLUYE_WEB' && ticket.custom_data && ticket.custom_data.skip_line;

                if(ticket.type !== 'DELIVERY' && !ticket.table_name && (ticket.source == 'INFLUYE_ADMIN' || ticket.source == 'INFLUYE_TOTEM' || skipLineOrder) && ticket.status == 'PENDING')
                {
                    ret[ticket.custom_data.preparation_at ? 'ready' : 'preparing'].push(ticket.id_ticket.toString().substr(-this.numberSize));
                }
            });
            return ret;
        }
    }
}
</script>

<style lang="scss">

</style>